/* istanbul ignore file */

import { graphql } from "gatsby";
import React from "react";
import type { VideoCarouselDataFragment } from "../../../graphql-types";
import { VideoPlayer } from "../VideoPlayer";

export default function VideoCarouselSection(props: VideoCarouselDataFragment) {
  const { videos } = props;

  return (
    <>
      <style>
        {`
          .slider {
            text-align: center;
          }

          .slides {
            display: flex;

            overflow-x: auto;
            scroll-snap-type: x mandatory;

            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;

            scroll-snap-type: mandatory;
          }

          .slides::-webkit-scrollbar {
            display: none;
          }

          .slides > div {
            scroll-snap-align: start;
            flex-shrink: 0;
            width: 100%;
            padding-left: 50px;
            padding-right: 50px;

            margin-left: -50px;
            margin-right: -50px;

            border-radius: 10px;
            background: transparent;
            transform-origin: center center;
            transform: scale(1);
            transition: transform 0.5s;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 100px;
          }

          .slides > div:first-of-type {
            margin-left: 0px;
          }

          @media screen and (min-width: 768px) {
            .slides > div {
              width: auto;
              padding-left: 20px;
              padding-right: 20px;
              margin-left: 0px;
              margin-right: 0px;
            }
          }
        `}
      </style>
      <div className="slider">
        <div className="slides">
          {videos.map(({ video }, index) => {
            if (!video.cdnVideo) {
              throw new Error("Could not get CDN video path");
            }
            return (
              <div id={`slide-${index}`}>
                <div className="max-w-lg mx-auto px-4">
                  <VideoPlayer
                    className="w-full h-auto max-w-full border border-gray-200 rounded-lg"
                    data-testid="video"
                    poster={video.cdnVideo.posterPath}
                    path={video.cdnVideo.path}
                    title={video.description || undefined}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
export const fragment = graphql`
  fragment VideoCarouselData on VideoCarousel {
    videos {
      autoPlay
      video {
        description
        cdnVideo {
          path
          posterPath
        }
      }
    }
  }
`;
